import { Validator } from '@vista-digital/validator';
import { FieldFormatType } from '../../../../types/form/field-format-type';
import { emailFieldValidationConfigValidator, otherFieldValidationConfigValidator, textFieldValidationConfigValidator } from '../../../../types/form/field-validation-config';
export const defaultMemberPasswordResetCreateFormValidationConfig = {
    email: { type: FieldFormatType.Email },
    username: { type: FieldFormatType.Text, maxLength: 100 },
    captcha: { type: FieldFormatType.Other, required: true }
};
export const memberPasswordResetCreateFormValidationConfigValidator = Validator.object({
    email: emailFieldValidationConfigValidator,
    username: textFieldValidationConfigValidator,
    captcha: otherFieldValidationConfigValidator
});
